export class HttpError extends Error {
	constructor(data) {
		super(`Error in ${data.method} ${data.requestUrl} [${data.status}]`); // (1)
		this.name = "HttpError"; // (2)
		this.data = data;
	}
}
